import { apiPost } from '../api';
import { ApiNames, ApiPath } from '../enums';

import { InvestmentBody } from './model';

interface InvestIntoProperty extends InvestmentBody {
  isCrowdfundingInvestmentRound: boolean;
}

export async function investIntoProperty({
  transactionId,
  investmentRoundId,
  investmentAmount,
  isCrowdfundingInvestmentRound,
}: InvestIntoProperty): Promise<void> {
  const body: InvestmentBody = { transactionId, investmentAmount, investmentRoundId };
  if (!isCrowdfundingInvestmentRound) {
    await investIntoParticipationProperty(body);
  } else {
    await investIntoCrowdfundingProperty(body);
  }
}

async function investIntoCrowdfundingProperty(body: InvestmentBody): Promise<void> {
  await apiPost<unknown, InvestmentBody>(ApiNames.MonorepoApiEndpoint, ApiPath.InvestIntoProperty, body, true);
}

async function investIntoParticipationProperty(body: InvestmentBody): Promise<void> {
  await apiPost<unknown, InvestmentBody>(
    ApiNames.MonorepoApiEndpoint,
    ApiPath.InvestIntoParticipationProperty,
    body,
    true
  );
}
